import { gql } from '@apollo/client';
import { CsvSitesResponseDto } from '../../../../client/graphql/graphql';

export type CSVSitesResponse = {
  downloadURL: CsvSitesResponseDto['downloadURL'];
};

export const csvSitesGql = gql`
  query csvSites($status: String, $targetTZ: String!) {
    csvSites(status: $status, targetTZ: $targetTZ) {
      downloadURL
    }
  }
`;
